<div class="track-my-location-container static-mobile-page">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12">
        <!-- <a href="" target="_blank"> -->
          <picture>
            <source srcset="/assets/images/temp/tms-logo-left-dark.svg" media="(prefers-color-scheme: dark)">
            <img width="200" [src]="logoPath" alt="Logo">
          </picture>
        <!-- </a> -->
      </div>
    </div>
    <div class="  col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>
    <div *ngIf = "supportData" class="col-12" style="
    margin-right: 4em;
    padding: 23px;
    font-size: 10px;">
    <div class="  col-12 md:col-12 lg:col-12">
      <h2>Want to get in touch? We would love to hear from you.
        You can reach out to us on :</h2>
    </div>
      <div *ngIf="supportData && supportData.organisationName" class="  col-12 md:col-12 lg:col-12">
        <h2>Organization Name : {{supportData.organisationName}}</h2>
      </div>
      <div *ngIf="supportData && supportData.website" class="  col-12 md:col-12 lg:col-12">
        <h2>Website : {{supportData.website}}</h2>
      </div>
      <div *ngIf="supportData['email']" class="  col-12 md:col-12 lg:col-12">
        <h3>Email : {{supportData['email']}}</h3>
      </div>
      <div *ngIf = "supportData.contacts.length > 0">
        <div *ngFor = "let eachnumber of supportData.contacts ; index as i" class="  col-12 md:col-12 lg:col-12">
          <h3>Support Number {{(i+1)}} : <a [href]="'tel:'+eachnumber">{{eachnumber}}</a></h3>
        </div>
      </div>
      <div *ngIf=" supportData && supportData.addressLine1" class="  col-12 md:col-12 lg:col-12">
        <h2>Address : {{supportData.addressLine1}} ,{{supportData.addressLine2}}</h2>
      </div>
     
    </div>
  </div>
</div>
